// Tenant Admin renders the selected panel from route metadata rather than a
// nested <RouterView>, but Vue Router still requires a component on each
// canonical child route.
const RouteState = { render: () => null };

const workflowRoute = (path, name, workflowTab) => ({
  path,
  name,
  component: RouteState,
  meta: { adminTab: 'Workflow Configuration', workflowTab },
});

export const WORKFLOW_CONFIGURATION_ROUTES = [
  workflowRoute(
    'workflow-configuration/task-statuses',
    'AdminWorkflowTaskStatuses',
    'task-statuses'
  ),
  workflowRoute(
    'workflow-configuration/instruction-types',
    'AdminWorkflowInstructionTypes',
    'instruction-types'
  ),
  workflowRoute(
    'workflow-configuration/task-configuration',
    'AdminWorkflowTaskConfiguration',
    'task-configuration'
  ),
  workflowRoute(
    'workflow-configuration/task-configuration/:taskTypeId(\\d+)',
    'AdminWorkflowTaskConfigurationDetail',
    'task-configuration'
  ),
  workflowRoute(
    'workflow-configuration/metric-workflows',
    'AdminWorkflowMetricWorkflows',
    'metric-workflows'
  ),
  workflowRoute(
    'workflow-configuration/metric-workflows/:metricId(\\d+)',
    'AdminWorkflowMetricWorkflowDetail',
    'metric-workflows'
  ),
  workflowRoute(
    'workflow-configuration/work-types',
    'AdminWorkflowWorkTypes',
    'work-types'
  ),
];
